import apis from "../common/apis";
import { IWarranty } from "../models/warrantyModel";
import {
  HTTP_METHOD_GET,
  HTTP_METHOD_POST,
  HTTP_METHOD_PUT,
} from "../utils/constant";
import { callApi } from "./fetchTools";

export default {
  getInfoWarranty: (uid: string) => {
    return callApi<IWarranty>(HTTP_METHOD_GET, `${apis.warranty}${uid}`, {});
  },
  getInfoWarrantyWeb: (uid: string) => {
    return callApi<IWarranty>(
      HTTP_METHOD_GET,
      `${apis.warranty}web/${uid}`,
      {}
    );
  },
  validateWarrantyInfo: (uid: string, keyword: string) => {
    return callApi<IWarranty>(HTTP_METHOD_POST, `${apis.warranty}${uid}`, {
      keyword,
    });
  },
  submitActiveWarrantyInfo: (model: any) => {
    return callApi<any>(HTTP_METHOD_POST, apis.warranty, model);
  },
  validateOTPActiveWarrantyInfo: (otp: string, uid: string) => {
    return callApi<any>(HTTP_METHOD_PUT, apis.warranty, { otp, uid });
  },
};
